import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';
import Table from '../../components/Table';
import Icon from '../../components/Icon';
import Header from '../../components/Header';
import './styles.css';

class AMSubscriptionRow extends React.PureComponent {
  static propTypes = {
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    connection: PropTypes.bool,
    majors: PropTypes.bool,
    academicThreshold: PropTypes.bool,
    location: PropTypes.string,
    diversity: PropTypes.string,
    competitors: PropTypes.string,
    activeSubscriptions: PropTypes.shape({
      connection: PropTypes.bool,
      advancedAwareness: PropTypes.bool,
    }),
  };

  setInactiveStatus = (isSubscriptionEnabled, content) => {
    if (isSubscriptionEnabled) {
      return content;
    }
    return <span><Icon name="warning" styleName="times-grey" />Inactive</span>;
  }

  render() {
    const { location, diversity, competitors, startDate, endDate, connection, majors, academicThreshold,
      activeSubscriptions,
    } = this.props;
    return (
      <Table.Row>
        <Table.Cell width="4" data-cy="overview-connection-table-audience">
          <Header as="h3" size="small" styleName="colHeader">
            {location.split('|').map((item) => <div key={item}>{item}</div>)}
            <div styleName="italicFont">{diversity}</div>
          </Header>
          <div styleName="greyDates"><FormattedDate
            year="numeric"
            month="numeric"
            day="numeric"
            value={startDate}
          /> - <FormattedDate
            year="numeric"
            month="numeric"
            day="numeric"
            value={endDate}
          />
          </div>
        </Table.Cell>
        <Table.Cell width="3" data-cy="overview-connection-table-competitors">
          { this.setInactiveStatus(activeSubscriptions.advancedAwareness,
            competitors ?
              <span>{competitors}</span>:
              <span styleName="italicFont">No Competitors Available</span>)}
        </Table.Cell>
        <Table.Cell width="2" data-cy="overview-connection-table-majors">
          { this.setInactiveStatus(activeSubscriptions.advancedAwareness,
            majors ?
              <span> <Icon name="checkmark" styleName="checkmark-green" /> Enabled </span>:
              <span> <Icon name="x" styleName="times-grey" /> Disabled </span>)}
        </Table.Cell>
        <Table.Cell width="2" data-cy="overview-connection-table-connection">
          { this.setInactiveStatus(activeSubscriptions.connection,
            connection ?
              <span> <Icon name="checkmark" styleName="checkmark-green" /> Enabled </span>:
              <span> <Icon name="x" styleName="times-grey" /> Disabled </span>)}
        </Table.Cell>
        <Table.Cell width="3" data-cy="overview-connection-table-academic-threshold">
          {academicThreshold ?
            <span> <Icon name="checkmark" styleName="checkmark-green" /> Enabled </span>:
            <span> <Icon name="x" styleName="times-grey" /> Disabled </span>}
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default AMSubscriptionRow;
